/**
 * Frontend theme JavaScript
 */

// Import SCSS for webpack processing
import '../sass/theme.scss';

// Import components
import './header.js';
import { initFooter } from './footer.js';
import { initFAQs } from './faqs.js';
import { initVideoControls } from './video-controls.js';
// Additional components will be added as needed in the future


// DOM Ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('🚀 Theme JavaScript initialized');
    
    // Initialize components
    initFooter();
    initFAQs();
    initVideoControls();
    
    console.log('✅ Theme ready for component development');
});